module.exports = {
  "language": "<a href=\"/en/login\">English</a> | <a href=\"/zh-cn/login\">简体中文</a> | <a href=\"/zh-tw/login\">繁體中文</a>",
  "userProc": "Data Maintain",
  "userProc_01": "AWB/BL Query",
  "userProc_02": "Append Airfreight AWB",
  "userProc_03": "Append Seafreight BL",
  "adminProc": "Sys. Maintain",
  "adminProc_01": "Append User",
  "adminProc_02": "Maintain User",
  "adminProc_03": "Append Status",
  "adminProc_04": "Maintain Status ",
  "adminProc_05": "Append Cust. Mail",
  "adminProc_06": "Maintain Cust.Mail",
  "user": "(User)AWB Query",
  "anonymou_cw": "CW",
  "company": "(Branch/Agent)AWB Query",
  "logon_out": "Exit",
  "logon_out_01": "Logout",
  "upload_INV_PO": "Upload INV & PO",
  "errorform": "AWB# can’t be null",
  "errorstate": "Status# can’t be null",
  "addokerror": "{0}AWB Appended!",
  "requst": "{0}must be filled!",
  "addother": "{0}appended successfully!",
  "errorall": "At least fill up one item!",
  "errorlogon": "Incorrect Login/Password!",
  "errorusercode": "User Code must be filled. ",
  "errorusername": "User Name must be filled. ",
  "errorctnr": "Container# must be filled!",
  "other1": "Invoice P/O Info",
  "other2": "AWB Status",
  "other3": "New User",
  "other4": "Status ",
  "other5": "User Mail Info",
  "other6": "Container Info",
  "existerror": "AWB#:{0} is existed, please check!",
  "existerruser": "User{0} is existed.",
  "existcnee": "Container#{0} is existed.",
  "existerrstatus": "Status Code {0} is existed.",
  "errorstatecode": "Status Code must be filled.",
  "error": "Error!",
  "error_in": "Possible causes of the error are:",
  "error_in_01": "You login session is expired, please re-login.",
  "error_in_02": "Incorrect or illegal hyperlink.",
  "error_in_03": "You don’t have right to access this page. ",
  "login": "Login ",
  "submit": "Submit",
  "reset": "Reset",
  "currpage": "Current Page:",
  "rec": "Record:",
  "currlocation": "Current Location",
  "inquiry": "Inquiry",
  "inputno": "AWB/BL#",
  "userid": "User ID",
  "password": "Password",
  "welcom": "Welcome to Soonest Global Logistics Tracking Information Web ",
  "home_img": "home_en.gif",
  "return_img": "return_en.gif",
  "home": "Back to Home ",
  "return": "Return to prev. page",
  "index": "First Page",
  "dot": "•",
  "result": "Query Result",
  "insert": "Append record ",
  "input": "Please input ",
  "logon_welcom": "Welcome logon ",
  "logon_guest": "Guest ",
  "totalcount": "Visitors Coun ",
  "search": "Search",
  "index_title": "GLS Tracking System",
  "index_word1": "Click to AWB/BL query (without login)",
  "index_word2": "Input AWB/BL# (Single number in a row only) ",
  "anonymou_title": "AWB/BL Query",
  "anonymou_currpage": "AWB/BL Query Result ",
  "anonymou_house_no": "AWB/BL# ",
  "anonymou_orgn_code": "Origin ",
  "anonymou_dest_code": "Dest. ",
  "anonymou_qty": "Qty ",
  "anonymou_gw": "GW",
  "anonymou_vw": "VW.",
  "anonymou_state_dates31": "ETD",
  "anonymou_state_dates33": "ETA",
  "anonymou_detail": "Details",
  "anonymoudetail_title": "AWB/BL Info ",
  "anonymoudetail_statedetail": "AWB/BL Status Detail ",
  "anonymoudetail_state": "AWB/BL Status Start ",
  "anonymoudetail_remake": "Remark ",
  "normal_title": "User AWB/BL Query ",
  "air": "Airfreight Query Result ",
  "sea": "Seafreight Query Result ",
  "normal_detail": "AWB/BL Details <br>(P/O Inv | Doc | Status)",
  "normal_detailsea": "AWB/BL Details <br>(Ctnr# | P/O Inv | Doc | Status)",
  "normal_word1": "Condition",
  "normal_selectawb": "AWB/BL#",
  "normal_to1_code": "AIRPORT ",
  "normal_selectinv": "INV# ",
  "normal_selectpo": "P/O# ",
  "normal_selectpart": "Part# ",
  "normal_selectcont": "Ctn# ",
  "normal_etd": "ETD",
  "normal_inqtype": "Query Type ",
  "normal_air": "Airfreight",
  "normal_sea": "Seafreight",
  "normal_state_dates31": "ETD",
  "normal_word2": "Container",
  "normal_word3": "P/O Inv",
  "normal_word4": "Doc.",
  "normal_word5": "Status",
  "normal_doc_title": "Doc. info",
  "normal_info": "Details ",
  "normal_billtype": "AWB Type",
  "normal_mawb": "MAWB#",
  "normal_billdate": "AWB Date ",
  "normal_shprename": "Shipper",
  "normal_shprcode": "Shipper#",
  "normal_shpradd": "Shipper Addr.",
  "normal_orgncode": "Orgn.",
  "normal_dest": "Dest.",
  "normal_fligde": "Flight Schedule",
  "normal_city": "City",
  "normal_flino": "Flight#",
  "normal_inq_etd": "ETD",
  "normal_eta": "ETA",
  "normal_first": "1st Route ",
  "normal_sec": "2nd Route ",
  "normal_thir": "3rd Route ",
  "normal_pkg": "Total Pkg. ",
  "normal_pkgde": "Pkg. Description ",
  "normal_comm": "Commodity ",
  "normal_marks": "Marks ",
  "normal_descp": "Description ",
  "normal_consignee": "Consignee",
  "normal_cneecode": "Consignee# ",
  "normal_cneeadd": "Consignee Addr. ",
  "normal_sea_closedate": "Close Date ",
  "normal_sea_etd": "ETD ",
  "normal_sea_eta": "ETA ",
  "normal_sea_loading": "Loading Type ",
  "normal_sea_portre": "Port of Rcv. ",
  "normal_sea_portl": "Port of Loading ",
  "normal_sea_portdh": "Port of Discharge",
  "normal_sea_protdl": "Port of Delivery",
  "normal_cnee_curr": "Container ",
  "normal_cnee_container": "Ctnr# ",
  "normal_cnee_seal": "Seal# ",
  "normal_cnee_type": "Ctnr Type ",
  "normal_cnee_load": "Load Type ",
  "normal_cnee_cuft": " CBM/CBF",
  "normal_sea_cbm": "CBM",
  "normal_sea_cbf": "CBF",
  "normal_po_title": "P/O INV ",
  "normal_po_inv": "INV#",
  "normal_po_no": "P/O#",
  "normal_po_part": "Part# ",
  "normal_po_remark": "Remark ",
  "normal_po_cartonno": "Ctn# ",
  "normal_state_title": "Status details",
  "company_title": "AWB/Bl Query",
  "company_inquiryby": "Query by",
  "company_house": "AWB",
  "company_masterno": "MAWB#",
  "company_houseno": "AWB# ",
  "company_consol": "Consol Data",
  "company_consol_detail": "Consol Details",
  "document_word1": "Operation",
  "document_word2": "Mod.",
  "document_word3": "Del.",
  "document_invpo_title": "Append/Modify INV/PO Info",
  "document_state_title": "Append/Modify AWB/BL Status Info",
  "document_state_code": "Status# ",
  "document_state_ename": "Status Name(Eng)",
  "document_state_cname": "Status Name(TC)",
  "document_state_sname": "Status Name(SC)",
  "document_state_date": "Status Date/Time",
  "document_cnee_title": "Append/Modify Ctnr Info",
  "document_air_title": "Append/Modify AWB Info",
  "document_sea_title": "Append/Modify BL Info",
  "pkg": "Pkg.",
  "gw": "GW",
  "cw": "CW",
  "vw": "VW",
  "currency": "Crncy.",
  "freight": "Freight",
  "other": "Other",
  "vessel": "Vessel ",
  "voyage": "Voyage",
  "carrier": "Carrier",
  "invoice": "INV ",
  "document": "DOC",
  "declaration": "DECL.#",
  "delivery": "Delivery#",
  "norecord_word1": "Sorry, we cannot find your record.",
  "admin_user_title": "Append/Modify User Info",
  "admin_user_submit": "Query ",
  "admin_user_code": "User Code ",
  "admin_user_name": "User Name ",
  "admin_user_type": "User Type ",
  "admin_user_pass": "User Pass ",
  "admin_user_email": "Email",
  "admin_user_typeA": "Admin",
  "admin_user_typeB": "General User ",
  "admin_user_typeC": "CO. User ",
  "admin_user_typeD": "Data Maintain ",
  "admin_status_title": "Append/Modify Status Info ",
  "admin_status_code": "Status Code ",
  "admin_status_ename": "Status Name(Eng)",
  "admin_status_cname": "Status Name(TC)",
  "admin_status_sname": "Status Name(SC)",
  "admin_mailout_title": "Append/Modify Cust. Mail ",
  "admin_mailout_email": "Email",
  "select_all": "All",
  "freight_s": "Term",
  "export_excel": "Export Excel",
  "no_upload_file": "No Upload file",
  "save_upload_file_error": "Save Upload file error",
  "successful_upload": "Successful upload file,Parsing data..",
  "msg_manifest_content_error": "The %s row %s data is error!",
  "msg_error1": "The %s row [%s] no find",
  "msg_error2": "The %s row must be [%s]",
  "msg_error3": "Data Save Successful",
  "msg_error4": "Data Save Error",
  "m_Download_title1": "Download Excel Template",
  "export_excel1": "Export Transit Excel",
  "IM_EX_Report": "Import & Export Report",
  "IM_EX_Report_time": "DateTime",
  "IM_EX_Report_total": "Total",
  "illegal_request_parameters": "Illegal Request Parameters",
  "login_expired": "Login has expired, please log in again",
  "request_timeout": "Service response timed out, please try again later!",
  "network_error": "Unable to access the service, the service does not exist or the network is not connected",
  "userAccess_authenticate_user_code_is_required": "User Code Is Required",
  "userAccess_authenticate_user_name_is_required": "User Name Is Required",
  "userAccess_authenticate_user_pass_is_required": "User Pass Is Required",
  "airway_bill_of_lading_least_one": "Enter at least one bill of lading number!",
  "page_not_exist": "Page does not exist",
  "back_to_login": "Back to login",
  "Quarterly_Report": "Quarterly Report",
  "Monthly_report": "Monthly & Comparison Report",
  "comparison": "Select Comparison Month",
  "comparison_tile": "Please select the Month of comparison",
  "Please_select_Origin_or_Dest": "Please select  Origin  or Dest",
  "Select_month": 'Select Month',
  "open": 'open',
  "close": 'close',
  "Please_select_Month": 'Please select Month',
  "difference": 'difference',
  'download': 'download'
}
